// import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../../environment/environment";
import NoRecordsRow from "../../../shared/UI/no-records-table-row";
import { formatDateString } from "../../../shared/services/helper";
import _axiosInstance from "../../../shared/services/axios.instance";
import showAlert from "../../../shared/services/alert.service";
const AdminMessage = () => {
  const [messageList, setMessage] = useState([]);
  useEffect(() => {
    getMessages();
  }, []);
  const getMessages = async () => {
    await _axiosInstance
      .get(`${apiUrl}contact/getMessages`, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          setMessage(res.data.data);
        } else {
          setMessage([]);
        }
      });
  };
  const onDeleteHandler = async (value) => {
    if (
      window.confirm(
        "Are you sure you want to delete message from " + value.name + "?"
      )
    ) {
      const res = await _axiosInstance.delete("contact/delete?id=" + value.id);
      if (res.data.status === "ok") {
        showAlert("success", res.data.message);
        getMessages();
      } else {
        showAlert("error", res.data.message);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="container">
        <div className="title">
          <h2>Messages</h2>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                {/* <th scope="col">#</th> */}
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Subject</th>
                <th scope="col">Message</th>
                <th scope="col">Created At</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {messageList && messageList.length > 0 ? (
                messageList.map((msg) => {
                  return (
                    <tr key={msg.id}>
                      {/* <th scope="row">1</th> */}
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.subject}</td>
                      <td>{msg.message}</td>
                      <td>{formatDateString(msg.createdAt)}</td>
                      <td>
                        <button
                          className="btn btn-outline-danger btn-sm mt-2 w-100"
                          onClick={() => {
                            onDeleteHandler(msg);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NoRecordsRow colSpan="6" align="center"></NoRecordsRow>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};
export { AdminMessage };
